"use client"

import { Suspense, useState, useEffect } from 'react';
import { Logo, Menu, Profile, Search } from 'mmds';
import { HeaderNavCallbacks } from './types';
import CartIndicator from '@app/components/cart-indicator/cart-indicator';
import Linker from '@app/components/linker/linker';
import { Language } from '@app/lib/store-context/Context';
import Toolbar from '../ui/toolbar/Toolbar';
import {
    addScrollDirectionListener,
    removeScrollDirectionListener,
} from '@app/lib/observers/throttled-scroll-direction-listener';
import cn from 'clsx';
import s from './header-nav.module.css';

const HeaderNavMobile = ({
    callbacks,
    lang,
}: {
    callbacks: HeaderNavCallbacks;
    lang: Language;
}) => {
    const [scrollDirection, setScrollDirection] = useState<string>('down');

    useEffect(() => {
        addScrollDirectionListener(window, setScrollDirection, 50);
        return () =>
            removeScrollDirectionListener(window, setScrollDirection, 50);
    }, []);

    return (
        <Suspense fallback={<div>Loading navigation...</div>}>
            <Toolbar
                shouldStick={scrollDirection === 'up'}
                position="top"
                variant="headerNav"
            >
                <div className={cn(s.root, s.mobile, 'mmds-copy-three')}>
                    <div className={cn(s.primary)}>
                        <div
                            className={cn(s.item, s.mobile)}
                            key={'mobile_menu_icon_button'}
                            data-testid={`mn-navigation-menu`}
                            onClick={callbacks.toggleMenu}
                        >
                            <Menu />
                        </div>
                        <div
                            className={cn(s.item, s.mobile)}
                            key={'mobile_search_icon_button'}
                            data-testid={`mn-search`}
                            onClick={() => callbacks.toggleSearch()}
                        >
                            <Search />
                        </div>
                    </div>
                    <div className={s.logo} data-testid={`dn-logo`}>
                        <Linker
                            href={'/'}
                            title={'MAAP Cycling Apparel Home'}
                            lang={lang}
                        >
                            <Logo />
                        </Linker>
                    </div>
                    <div className={cn(s.support, s.mobile)}>
                        <div
                            className={cn(s.supportItem, s.end, s.mobile)}
                            onClick={callbacks.toggleProfile}
                        >
                            <Profile />
                        </div>
                        <div
                            className={cn(s.supportItem, s.end, s.mobile)}
                            onClick={callbacks.toggleCart}
                        >
                            <CartIndicator />
                        </div>
                    </div>
                </div>
            </Toolbar>
        </Suspense>
    );
};

export default HeaderNavMobile;
